import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText 
} from '@mui/material';
import { Resource } from '../../types';

interface ResourceSelectProps {
  resources: Resource[];
  value: number | '';
  onChange: (resourceId: number | '') => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

/**
 * A reusable component for selecting a resource from a dropdown list
 */
const ResourceSelect: React.FC<ResourceSelectProps> = ({
  resources,
  value,
  onChange,
  error,
  disabled = false,
  required = true,
  label = 'Resource'
}) => {
  return (
    <FormControl fullWidth error={!!error} disabled={disabled} required={required}>
      <InputLabel id="resource-select-label">{label}</InputLabel>
      <Select
        labelId="resource-select-label"
        value={value}
        label={label}
        onChange={(e) => {
          const selectedValue = e.target.value;
          onChange(selectedValue === '' ? '' : Number(selectedValue));
        }}
      >
        <MenuItem value=""><em>Select a resource</em></MenuItem>
        {resources.map((resource) => (
          <MenuItem key={resource.id} value={resource.id}>
            {resource.name} ({resource.category})
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default ResourceSelect;
